import React, { Component } from 'react';
import { Table } from 'antd';
import PropTypes from 'prop-types';
import styles from './TableContent.module.scss';
import { XPagination } from '@/components/xqxc_ui';
import { tooltipStyle, tooltip, tooltipClick } from '@/components/TableCell';
import { regFenToYuan, } from '@/util/money';
import { FloatConversion } from '@/util/conversion';


//模拟表格数据   
const tableDataSource = [];
for (let i = 0; i < 50; i++) {
    tableDataSource.push({
        c1: i % 2 === 0 ? '等级增长奖励' : '随机订单奖励',
        c2: i % 2 === 0 ? '+1' : '-53',
        c3: i % 2 === 0 ? '+156.12' : '456',
        c4: i % 2 === 0 ? '拉黑7天' : '',
        c5: i % 2 === 0 ? '处罚' : '奖励',
        c6: '2020-11-29 10:03:55 - 2020-11-30 10:03:55',
        c7: i % 2 === 0 ? '已结束' : '未开始',
        id: i,
    });
}


export default class TableContent extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.floatConversion = new FloatConversion();
    }
    _columns = () => ([
        {
            title: '奖惩名称',
            dataIndex: 'c1',
            key: 'c1',
            width: '12%',
            align: 'center',
            onCell: tooltipStyle,
            render: (text, record) => tooltipClick(text, () => this.props.tableAction(record, 'detail'))
        },
        {
            title: '奖惩等级分',
            dataIndex: 'c2',
            key: 'c2',
            width: '8%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '奖惩现金(元)',
            dataIndex: 'c3',
            key: 'c3',
            width: '8%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '其它奖惩',
            dataIndex: 'c4',
            key: 'c4',
            width: '8%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '类型',
            dataIndex: 'c5',
            key: 'c5',
            width: '8%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '起止时间',
            dataIndex: 'c6',
            key: 'c6',
            width: '20%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '状态',
            dataIndex: 'c7',
            key: 'c7',
            width: '8%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作',
            dataIndex: 'id',
            key: 'id',
            align: 'center',
            width: '12%',
            render: (id, record) => this._tableAction(id, record)
        }
    ]);

    _tableAction = (id, record) => {
        const { tableAction } = this.props;
        const { status: { code } = {}, triggerType = {} } = record;
        return (< div className={styles.action} >
            <div className={styles.item} onClick={() => tableAction(id, 'editor')}>编辑</div>
            <div className={styles.item} onClick={() => tableAction(id, 'delete')}>删除</div>
            <div className={styles.item} onClick={() => tableAction(id, 'end')}>终止</div>
            {/* {code == 'INIT' && <div className={styles.item} onClick={() => tableAction(id, 'editor')}>编辑</div>} */}
            {/* {code == 'INIT' && <div className={styles.item} onClick={() => tableAction(id, 'delete')}>删除</div>} */}
            {/* {(code == 'PROCESSING' && triggerType.code != 'RANDOM') && <div className={styles.item} onClick={() => tableAction(id, 'end')}>终止</div>} */}
            {/* {code == 'PROCESSING' && <div className={styles.item} onClick={() => tableAction(id, 'end')}>终止</div>} */}
        </div >);
    };

    // 解析表格数据，使符合columns格式要求
    _takeDataSource = (data) => {
        if (data) {
            return data.map(item => {
                //处理奖惩符号
                let { incrDecrFlag: { code = 'default' } = {} } = item;
                let decObg = {
                    ADD: '+',
                    REDUCE: '-',
                    default: '',
                };
                item.rewardValueDec = item.rewardValue == '0' ? item.rewardValue : `${decObg[code]}${regFenToYuan(item.rewardValue)}`;
                item.lvNumDec = item.lvNum == '0' ? item.lvNum : `${decObg[code]}${item.lvNum}`;
                item.serviceNumDec = item.serviceNum == '0' ? item.serviceNum : `${decObg[code]}${item.serviceNum}`;
                item.startStopTime = `${item.gmtStart} - ${item.gmtEnd}`;
                item.pullBlackValue = item.pullBlack ? `拉黑${this.floatConversion.divide(item.pullBlack, 1440)}天` : '';
                return item;
            });
        }
    }

    //渲染组件
    render() {
        const { paginationChange } = this.props;
        const { pageNum, pageSize, resultTotal, dataList } = this.props.renderData;
        return (
            <div className={styles.tableContainer}>
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    rowKey={(record) => record.id}
                    columns={this._columns()}
                    dataSource={this._takeDataSource(tableDataSource)}
                    pagination={false}
                    scroll={{ y: true }}
                />
                <XPagination
                    resultTotal={resultTotal}
                    pageSize={pageSize}
                    pageNum={pageNum}
                    onChange={paginationChange}
                />
            </div>
        );
    }
}

TableContent.propTypes = {
    renderData: PropTypes.object, // 表格数据源
    paginationChange: PropTypes.func, // 分页
    tableAction: PropTypes.func, // 对表格的操作
};